export const KEY = 'top_level_source';

export const SOURCES = {
    LANDING_PAGE: 'landing_page',
    TAG_PAGE: 'tag_page',
    MARKETPLACE: 'marketplace',
    LIGHTRICKS: 'lightricks',
    LOHP_BANNER: 'LOHP_banner',
};

export const BOOSTED_DEEP_LINK_REGEX = /boostedDeepLink/;
